<div class="reconnectDisplay column t-{{activeTheme.theme}}-dialog">
  <div class="messageBlock">{{ "SUCCESSFULLY_DISCNNECTED" | translate }}</div>
  <button mat-raised-button color="primary" class="reconnectButton" (click)="reconnect()">{{ "RECONNECT" | translate }}</button>
</div>
